import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { FooterStyle } from './Footer.styles';
/**
 * Themeable footer that acts as a container for all footer contents
 *
 * ```js
 * import { Footer } from '@minerva-analytics/pantheon';
 * <Footer> Footer Content </Footer>
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [Footer.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/Footer/Footer.styles.js)
 *
 */

export var FooterComponent = function FooterComponent(_ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(FooterStyle, rest);
};
var Footer = createThemedComponent('Footer', FooterStyle);
export default Footer;